import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // Controller conectado
    this.setupFormValidation();
  }

  disconnect() {
    // Remover event listener do formulário
    const form = document.getElementById('main_form');
    if (form && this.handleFormSubmit) {
      form.removeEventListener('submit', this.handleFormSubmit);
    }
  }

  setupFormValidation() {
    // Adicionar validação ao formulário
    const form = document.getElementById('main_form');
    if (form) {
      // Armazenar referência da função para poder remover depois
      this.handleFormSubmit = (event) => {
        // Verificar se há um campo de descrição do Summernote no formulário
        const descriptionField = form.querySelector(
          '[name="questions_model[question_content_attributes][description]"]',
        );
        if (descriptionField) {
          // Obter o conteúdo do Summernote
          const summernoteElement = form.querySelector('[data-provider="summernote"]');
          if (summernoteElement && $(summernoteElement).summernote) {
            const content = $(summernoteElement).summernote('code');
            // Verificar se está vazio ou tem apenas tags HTML vazias
            const textContent = $('<div>').html(content).text().trim();
            if (textContent === '') {
              event.preventDefault();
              // Mostrar erro
              alert('Por favor, preencha o Texto da Questão');
              return false;
            }
          }
        }
      };

      form.addEventListener('submit', this.handleFormSubmit);
    }
  }

  onChangeAlternativeType(event) {
    const quantity = parseInt(event.target.value);
    const alternativesElements = document.querySelectorAll('[id^="alternative_"]');

    // Hide all alternatives first
    alternativesElements.forEach((alt) => {
      const input = alt.querySelector('textarea');
      if (input) {
        input.disabled = true;
      }
      alt.classList.add('tw-hidden');
    });

    // Show alternatives based on quantity
    if (quantity === 5) {
      for (let i = 1; i <= 5; i++) {
        const alt = document.getElementById(`alternative_${i}`);
        if (alt) {
          alt.classList.remove('tw-hidden');
          const input = alt.querySelector('textarea');
          if (input) input.disabled = false;
        }
      }
    } else if (quantity === 4) {
      for (let i = 1; i <= 4; i++) {
        const alt = document.getElementById(`alternative_${i}`);
        if (alt) {
          alt.classList.remove('tw-hidden');
          const input = alt.querySelector('textarea');
          if (input) input.disabled = false;
        }
      }
    } else if (quantity === 2) {
      [3, 5].forEach((i) => {
        const alt = document.getElementById(`alternative_${i}`);
        if (alt) {
          alt.classList.remove('tw-hidden');
          const input = alt.querySelector('textarea');
          if (input) input.disabled = false;
        }
      });
    }

    // Update correct alternative select
    const correctSelect = document.querySelector(
      '[name="questions_model[correct_alternative_number]"]',
    );
    if (correctSelect) {
      const currentValue = correctSelect.value;
      correctSelect.innerHTML = '<option value="">Selecione a alternativa correta</option>';

      if (quantity === 5) {
        for (let i = 1; i <= 5; i++) {
          correctSelect.insertAdjacentHTML(
            'beforeend',
            `<option value="${i}">${String.fromCharCode(64 + i)}</option>`,
          );
        }
      } else if (quantity === 4) {
        for (let i = 1; i <= 4; i++) {
          correctSelect.insertAdjacentHTML(
            'beforeend',
            `<option value="${i}">${String.fromCharCode(64 + i)}</option>`,
          );
        }
      } else if (quantity === 2) {
        correctSelect.insertAdjacentHTML('beforeend', '<option value="3">C</option>');
        correctSelect.insertAdjacentHTML('beforeend', '<option value="5">E</option>');
      }

      // Restore value if still valid
      if ([...correctSelect.options].some((opt) => opt.value === currentValue)) {
        correctSelect.value = currentValue;
      }
    }
  }
}
